import { CuttingState } from "./CuttingState.d";
import { ShipmentState } from "./ShipmentState.d";
import { ShipmentType } from "./ShipmentType.d";
import { UserType } from "./UserType.d";
import { CordwoodMeasurementType } from "./CordwoodMeasurementType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity Shipments


export interface Shipment {
    id: ID;

    
    key: string;

    
    reportKey: string;

    
    cuttingId: ID;

    
    storageId: ID;

    
    shipmentAt?: Date;

    
    shippingContractorUserId: ID;

    
    sourceLocationId?: ID;

    
    sourceParcel?: string;

    
    buyerId?: ID;

    
    targetAddress?: string;

    
    targetCity?: string;

    
    targetCountry?: string;

    
    state: ShipmentState;

    
    shipmentType: ShipmentType;

    
    roadCarrierId?: ID;

    
    truckRegistrationNumber?: string;

    
    truckerName?: string;

    
    workOrder?: string;

    
    shipmentOrder?: string;

    
    forPersonalUse?: boolean;

    
    description?: string;

    
    scopeGroupId: ID;

    }

export interface FilterAdvancedPresentationRequest {
    list: ListRequest,
    filter: {
        
            key?: string,
        
    
    

            reportKey?: string,
        
    
    
shipmentAtFrom?: Date,
            shipmentAtTo?: Date,
        
    
    shipmentAtInclude: boolean,

            buyerId?: ID,
        
    
    buyerIdInclude: boolean,

            state: ShipmentState[],
        
    
    

            shipmentType: ShipmentType[],
        
    
    

            shippingContractorUserId: ID[],
        
    
    



        cuttingIdRefs?: ID[],
        storageIdRefs?: ID[],
        shippingContractorUserIdRefs?: ID[],
        sourceLocationIdRefs?: ID[],
        buyerIdRefs?: ID[],
        roadCarrierIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}



export interface CreateShipment {
    
    key: string;

    
    
    
    storageId: ID;

    
    shipmentAt?: Date;

    
    shippingContractorUserId: ID;

    
    sourceLocationId?: ID;

    
    sourceParcel?: string;

    
    buyerId?: ID;

    
    targetAddress?: string;

    
    targetCity?: string;

    
    targetCountry?: string;

    
    state: ShipmentState;

    
    shipmentType: ShipmentType;

    
    roadCarrierId?: ID;

    
    truckRegistrationNumber?: string;

    
    truckerName?: string;

    
    workOrder?: string;

    
    shipmentOrder?: string;

    
    forPersonalUse?: boolean;

    
    description?: string;

    
    }


export interface UpdateShipment {
    
    key: string;

    
    
    
    
    shipmentAt?: Date;

    
    
    sourceLocationId?: ID;

    
    sourceParcel?: string;

    
    buyerId?: ID;

    
    targetAddress?: string;

    
    targetCity?: string;

    
    targetCountry?: string;

    
    state: ShipmentState;

    
    
    roadCarrierId?: ID;

    
    truckRegistrationNumber?: string;

    
    truckerName?: string;

    
    workOrder?: string;

    
    shipmentOrder?: string;

    
    forPersonalUse?: boolean;

    
    description?: string;

    
    }

export interface PresentationShipmentRequest {
    list: ListRequest,
    filter: {
        key: string,
        keyOr: boolean,
        reportKey: string,
        reportKeyOr: boolean,
        shipmentAt: Date,
        shipmentAtOr: boolean,
        cuttingIdRefs?: ID[],
        storageIdRefs?: ID[],
        shippingContractorUserIdRefs?: ID[],
        sourceLocationIdRefs?: ID[],
        buyerIdRefs?: ID[],
        roadCarrierIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryShipment {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: Shipment): PrimaryShipment | undefined {
        return entity ? new PrimaryShipment(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryShipment {
        return new PrimaryShipment(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryShipment {
        let vals = path?.split('/');
        return new PrimaryShipment(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryShipment[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: Shipment): string {
    let fields = entity ? [
    entity.key,
            entity.reportKey,
            displayDateTime(entity.shipmentAt),
            ] : [];
    return fields.filter(item => item).join(' | ');
}

export class UpdateEntityShipment {
    id: PrimaryShipment;
    data: UpdateShipment;


    constructor(id: PrimaryShipment, data: UpdateShipment) {
        this.id = id;
        this.data = data;
    }
}
